module.exports = __webpack_public_path__ + "static/img/logo.6c662d12.png";